/**
 * - `AGGREGATION_PENDING`  order which is not linked to an aggregation in any way. It is waiting to be
 *                          processed but the impact is still visible on the user's profile.
 *
 * - `AGGREGATION_LOCKED`   order is currently being assigned an aggregation & should not be handled by
 *                          any other workers
 *
 * - `AGGREGATION_COMPLETE` order was aggregated, with potentially some failures
 *
 * - `PAYMENT_PENDING`      order has been linked to an invoice.
 * - `PAYMENT_COMPLETE`     order has been paid for (the linked invoice has been paid).
 * - `PAYMENT_FAILED`       order had payment attempted, but failed to get funds
 *
 * - `DRAFT`                order has been linked to an invoice which is in a draft state
 * - `TEST`                 order made which should not be processed or linked to an invoice/aggregation
 * - `VOID`                 order which has been voided subsequent to being generated
 */
export enum ImpactOrderStatus {
  AGGREGATION_PENDING = 'AGGREGATION_PENDING',
  AGGREGATION_LOCKED = 'AGGREGATION_LOCKED',
  AGGREGATION_COMPLETE = 'AGGREGATION_COMPLETE',
  PAYMENT_PENDING = 'PAYMENT_PENDING',
  PAYMENT_FAILED = 'PAYMENT_FAILED',
  PAYMENT_COMPLETE = 'PAYMENT_COMPLETE',
  DRAFT = 'DRAFT',
  TEST = 'TEST',
  VOID = 'VOID',
}

export enum ImpactOrderVariant {
  API = 'API',
  FLIGHT_CALCULATOR = 'FLIGHT_CALCULATOR',
  IMPACT_SHOP = 'IMPACT_SHOP',
  INTEGRATION = 'INTEGRATION',
  ADMIN_PANEL = 'ADMIN_PANEL',
  SUBSCRIPTION = 'SUBSCRIPTION',
}

export enum ImpactOrderIntegration {
  SHOPIFY = 'SHOPIFY',
  ZAPIER = 'ZAPIER',
}
